import React from 'react';
import {Paper} from "material-ui";
import MapMarkerLegends from "./MapMarkerLegends";
import LeafletMap from "../common/LeafletMap";
import {inject, observer} from "mobx-react/index";
import {hashHistory} from "react-router";
import {observable} from "mobx/lib/mobx";
import {proxyUrl} from "../../libs/config";

@inject('markerStore')
@observer
export default class MapPageLeaflet extends React.Component {
  // constructor(props, context) {
  //   super(props, context);
  //   this.state = {
  //     station: {},
  //     data_series: [],
  //     curMar: {},
  //     markersData: []
  //   };
  // }

  // @observable selectedMarker = null;

  // handleMarkerClick = (marker) => {
  //   this.setState({curMar: Object.assign({}, marker)});
  //   this.props.markerStore.selectedMarker = marker;
  //   marker.showInfo = true;
  //   this.setState(this.state);
  // };

  handleMarkerClose = (marker) => {
    this.props.markerStore.selectedMarker = null;
    // marker.showInfo = false;
    // this.setState(this.state);
  };

  onMarkerClick = (marker, fromTitle) => {
    if (this.props.mobView) {
      fromTitle && hashHistory.push(`/basin/${marker.id}`);
    } else {
      hashHistory.push(`/basin/${marker.id}`);
    }
  };

  renderCustomInfoWindow = (marker) => {
    // let marker = this.props.markerStore.selectedMarker;
    if(!marker) return null;

    let title = `${marker.name} ${marker.stationIndex ? `(${marker.stationIndex})` : ''}`;

    // return(`
    //   <div>${title}</div>
    // `);

    return (
      <div className="info-window">
        <div>
          <a><p className="primart_text_color" style={{fontSize: '20px'}}
                onClick={() => this.onMarkerClick(marker, true)}>{title}</p></a>
          {marker.district && <p style={{fontStyle:'italic'}}>{marker.district}</p>}
          <span className="info-window-close glyphicon glyphicon-remove" onClick={this.handleMarkerClose}/>
        </div>
        <div style={{padding: '5px'}}>
          {marker.waterlevel &&
          <div>
            <b>{marker.waterlevel && marker.waterlevel.data.value}</b>
            <p>{marker.waterlevel && marker.waterlevel.data.datetime}</p>
          </div>}
          {marker.waterlevel && marker.waterlevel.thresholds &&
          <div>
            <div>{marker.waterlevel.thresholds.warning && `Warning Level : ${marker.waterlevel.thresholds.warning} m`}</div>
            <div>{marker.waterlevel.thresholds.danger && `Danger Level : ${marker.waterlevel.thresholds.danger} m`}</div>
          </div>}
          {marker.rainfall &&
          <table className="table" style={{marginBottom: '0px'}}>
            <caption>Accumulated Rainfall</caption>
            <tbody>{
              marker.rainfall.averages && marker.rainfall.averages.map((item, i) => (
                <tr key={i}>
                  <td>{`${item.interval} hours`}</td>
                  <td>{item.value === 'N/A' || item.value === null ? '-' : `${item.value} mm`}</td>
                </tr>
              ))
            }</tbody>
          </table>}
        </div>
      </div>
    );
  };

  getFilteredMarkers = (markers) => {
    const {filteredStations} = this.props;
    const filteredMarker = [];
    if (!filteredStations) {
      return markers;
    } else {
      // eslint-disable-next-line array-callback-return
      markers.map(marker => {
        if (filteredStations.filter(s => +s.id === +marker.id)[0]) {
          filteredMarker.push(marker);
        }
      });
      return filteredMarker;
    }
  };

  render() {
    const {markerStore} = this.props;
    // let layers = [{url: `${proxyUrl}/overlays/Nepal_New.kml`, style: {
    //   color: "#FF0000",
    //   weight: 1.5,
    //   fillOpacity: 0
    // }, alwaysDisplay: true}, {url: `${proxyUrl}/overlays/watershed_wgs.kml`, style: {
    //     color: "#FF0000",
    //     weight: 0.5,
    //     fillOpacity: 0
    //   }, alwaysDisplay: true}, ];
    let layers = [{url: `${proxyUrl}/overlays/Nepal_Basin_final.kml`, style: {
      color: "#FF0000",
      weight: 1.5,
      fillOpacity: 0
    }, alwaysDisplay: true}];
    let markers = this.getFilteredMarkers(markerStore.getCombinedMarkers);
      // .map(item => ({
      //   id: `station_marker-${item.id}`,
      //   position: [item.position.lat, item.position.lng],
      //   icon: `<img id=${'station_marker_image-'+item.id} src=${item.icon} />`,
      // }));

    return (
      <Paper zDepth={1} className='map-page' style={this.props.style}>
        <LeafletMap id='home_map' markers={Object.assign([], markers)} center={{lat: 28.082787, lng: 84.499982}} kmlLayers={layers} onMarkerClick={this.onMarkerClick}>
          {markerStore.selectedMarker ? this.renderCustomInfoWindow(markers.find(item => item.id === markerStore.selectedMarker)) : null}
        </LeafletMap>
        <MapMarkerLegends/>
      </Paper>
      );
  }
}


// WEBPACK FOOTER //
// ./src/components/Home/MapPageLeaflet.js